/**
 * Created by Hiren Dobariya
 */

define(function (require, exports, module) {

  'use strict';

  module.exports = function ($window) {
    return {
      restrict: 'AE',
      /*template  : '<input type="tel" ng-model="otp" set-focus />',
       scope:{
       otp:'='
       },*/
      scope: {
        otp: '=ngModel'
      },
      link: function (scope, element, attrs, ctrl) {
        var otpRegEx = /^\d$/;

        element.on('keypress', function (event) {
          event = event || $window.event;
          var evt = (event.charCode) ? event.charCode : ((event.which) ? event.which : event.keyCode);
          //keyCode : 8 = back, 9 = tab, 37 =right arrow, 94 & 224 = Ctrl, 86 = V,
          if (evt !== 13 && evt !== 8 && (angular.element(event.target).val().length > 5)) {
            event.preventDefault();
          }
          if (event.which) {
            if (evt !== 13 && evt !== 8 && !(evt === 118 || evt === 86) && !otpRegEx.test(String.fromCharCode(event.which))) {
              event.preventDefault();
            }
          }

        });

        element.on('paste', function (event) {
          event = event || $window.event;
          var otpOldVal = angular.element(event.target).val();
          angular.element(event.target).val('');
          var otpValue = '';

          if (event.originalEvent.clipboardData) {
            otpValue = (event.originalEvent || event).clipboardData.getData('text/plain');
          } else if ($window.clipboardData) {
            otpValue = $window.clipboardData.getData('Text');
          }

          var filterValue = '';
          var startPosition = 1;
          otpValue = otpOldVal + otpValue;

          angular.forEach(otpValue, function (value, key) {
            if (otpRegEx.test(value)) {
              if (startPosition <= 6) {
                filterValue += value;
              }
              if (startPosition === 6) {
                angular.element('#submitOtp').focus();
                angular.element(event.target).next().focus();
              }
              startPosition++;
            }
          });

          scope.otp = filterValue;
          scope.$apply();
          event.preventDefault();
        });

      }
    };
  };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/portal/otp.js
// module id = 12
// module chunks = 0